import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RiskReversalsComponent } from './risk-reversals/risk-reversals.component';
import { RiskPanelComponent } from './risk-reversals/risk-panel/risk-panel.component';
import { SymbolNavComponent } from './risk-reversals/symbol-nav/symbol-nav.component';
import { RiskreversalTableComponent } from './risk-reversals/riskreversal-table/riskreversal-table.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    DashboardComponent,
    RiskReversalsComponent,
    RiskPanelComponent,
    SymbolNavComponent,
    RiskreversalTableComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
